import { j as json } from './fetch-deps.js';

/**
 * Returns a GraphQL body payload.
 */
const data = (payload) => {
    return json({ data: payload }, { merge: true });
};

/**
 * Sets a given list of GraphQL errors on the mocked response.
 */
const errors = (errorsList) => {
    if (errorsList == null) {
        return (res) => res;
    }
    return json({ errors: errorsList }, { merge: true });
};

export { data as d, errors as e };
